module.exports = __webpack_public_path__ + "27391e8800e239d8170536c6c9c0ffd3.png";